import type {Item,Snapshot} from './model'
import {currentStop} from './unstickModel'
import {pendingActions} from './waitingPolicy'
export const recoveryGroups=['owner','agent','service','done'] as const
export type RecoveryGroup=typeof recoveryGroups[number]
export const recoveryLabels:Record<RecoveryGroup,string>={owner:'צריך אותך',agent:'הסוכנים מטפלים',service:'ממתין לסביבה',done:'הסתיים היום'}
export const terminal=(i:Item)=>['released','message_sent','no_fix','superseded'].includes(i.state)
export function recoveryGroup(i:Item,data:Snapshot):RecoveryGroup{
 if(terminal(i))return 'done'
 if(pendingActions(i,data).length)return 'owner'
 if(currentStop(i)||['stuck','failed','parked'].includes(i.state))return 'service'
 return 'agent'
}
export function israelDay(at:string){return new Date(at).toLocaleDateString('en-CA',{timeZone:'Asia/Jerusalem'})}
export const pendingDecision=(i:Item)=>terminal(i)?undefined:i.decision_history?.find(d=>d.job_id===i.active_job&&!d.chosen&&!d.reversed_at)
export function recoveryStep(i:Item){
 if(['superseded','no_fix'].includes(i.state))return -1
 if(terminal(i)||['ready','fix_ready','releasing','confirming'].includes(i.state))return 5
 if(['build','fix','verify'].includes(i.state))return 4
 if(i.decision_history?.some(d=>d.job_id===i.active_job&&!d.chosen&&!d.reversed_at)||['direction_ready','plan_ready','screens_ready'].includes(i.state))return 3
 if(i.decision_history?.some(d=>d.job_id===i.active_job&&d.factors.some(f=>f.key==='checker'&&f.points>0)))return 2
 return ['new','queued'].includes(i.state)?0:1
}
export function continuationAvailable(i:Item){return !!i.active_job&&!terminal(i)&&!['plan','screens','build','fix','verify','diagnose','queued','running','releasing'].includes(i.state)}
